import type { ElasticSearchResponse } from '../@types/ElasticSearchResponse';
import type { Manufacturer } from '../@types/Manufacturer';
import type { Actions } from '../actions';
import {
  RCV_MANUFACTURER_ACTIVE,
  RCV_MANUFACTURER_LIST,
  REQ_MANUFACTURER_ACTIVE,
  REQ_MANUFACTURER_LIST,
  REQUEST_FAILED,
} from '../actions/manufacturer';
import { requestStatus, responseStatus } from '../shared/statuses';

interface ManufacturersState {
  requestStatus: number;
  responseStatus: number;
  list?: ElasticSearchResponse<Manufacturer>;
  active: string[];
}

const _initialState: ManufacturersState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  active: [],
};

const manufacturersReducer = (
  state: ManufacturersState = _initialState,
  action: Actions,
): ManufacturersState => {
  switch (action.type) {
    case REQ_MANUFACTURER_LIST:
      return {
        ...state,
        list: undefined,
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_MANUFACTURER_LIST:
      return {
        ...state,
        list: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQ_MANUFACTURER_ACTIVE:
      return {
        ...state,
        active: [],
        requestStatus: requestStatus.FETCHING_LIST,
        responseStatus: responseStatus.PENDING,
      };
    case RCV_MANUFACTURER_ACTIVE:
      return {
        ...state,
        active: action.response,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.OK,
      };
    case REQUEST_FAILED:
      return {
        ...state,
        list: undefined,
        active: [],
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
      };
    default:
      return state;
  }
};

export default manufacturersReducer;
